import { Report1911Container } from "../../../containers/borrowSystem/Report/Report1911Container";

export function Report1911Page() {
    return (
        <Report1911Container />
    )
}